import clsx from 'clsx'
import { ConfirmationDialogRunning } from 'components/atoms/ConfirmationDialogRunning'
import { FullLoader } from 'components/atoms/FullLoader/FullLoader'
import { NoContactsFound } from 'components/templates/NoSearchResult'
import { campaignHooks } from 'features/campaigns'
import { hooks as ODataHooks } from 'shared/odata'
import { modal } from 'shared/styles'
import { ContactsTable, StackIcon } from 'shared/ui'
import { ControlledDialog } from 'shared/ui/Dialog'

import { api } from '../../api'
import { FilterHeader } from '../FilterHeader/FilterHeader'
import { NotExistYet } from '../NotExistYet/NotExistYet'
import css from './AddModal.module.css'
import { Table } from './Table'
import { close, open, useOpen } from './util'

AddModal.open = open

export function AddModal() {
	const isOpen = useOpen()

	const { isApplied, params } = ODataHooks.useParseUrl('Add')

	const { data, isFetching, isLoading, isSuccess } = api.useContactPageQuery(
		params,
		{
			refetchOnMountOrArgChange: true,
			skip: !isOpen
		}
	)

	ODataHooks.useCheckPagination({
		data,
		isApplied,
		isModal: true,
		isReady: isSuccess && !isFetching
	})

	const noRows = isSuccess && !isFetching && data?.total === 0,
		notExist = noRows && !isApplied,
		shouldShowTable = !isFetching && isSuccess && !notExist,
		isEmpty = shouldShowTable && noRows

	const total = data?.total ?? 0

	const showMainLoader = isLoading || (!notExist && !shouldShowTable)

	return (
		<>
			<ControlledDialog
				className={clsx(css.wrapper, {
					[css.centered]: isFetching,
					[css.empty]: isEmpty,
					[css.notExist]: notExist
				})}
				onRequestClose={close}
				open={isOpen}
				rootClassName={clsx(css.root, notExist && css.notExistWrap)}
			>
				<button className={modal.close} onClick={close} type='button'>
					<StackIcon icon='close' stroke='currentcolor' width={14} />
				</button>

				{showMainLoader && <FullLoader />}

				{(shouldShowTable || notExist) && <Title />}
				{shouldShowTable && (
					<>
						<FilterHeader isModal />
						{isFetching && ContactsTable.Spinner}

						{isEmpty ? (
							<NoContactsFound className={css.center} />
						) : (
							<Table
								contacts={data?.documents ?? []}
								filter={params}
								total={total}
							/>
						)}
					</>
				)}

				{notExist && <NotExistYet />}
			</ControlledDialog>
			{isOpen && <ConfirmationDialogRunning />}
		</>
	)
}

function Title() {
	const { campaign } = campaignHooks.useCurrent()

	const name = campaign?.name

	return (
		<h1 className={css.title}>
			{name && <span className={css.name}>{name}</span>}
			Add more contacts
		</h1>
	)
}
